import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useAuth } from "../context/AuthContext";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar"
import api from "../api/api";
import * as Icon from 'react-feather';
import UpdateProfileImage from "./UpdateProfileImage";
import { useForm } from "react-hook-form";
import { schema,schemaAgencyPlus } from "../schema/schemaCompanyDetails";
import { yupResolver } from "@hookform/resolvers/yup";
import AddressRegistration from "../authentication/common/AddressRegistration";
import { useTranslation } from "react-i18next";
const CompanyDetails = () => {
const { t } = useTranslation();
  const { user,setUser } = useAuth();
  const [menu, setMenu] = useState(false);
  const [show, setShow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const [loadingDetails, setLoadingDetails] = useState(false);
  const [data, setData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);



  const { reset, handleSubmit, setError, setValue, clearErrors,trigger, register, formState: { errors } } = useForm({
    resolver: user.type == "agency" ? yupResolver(schema(t).concat(schemaAgencyPlus(t))) : yupResolver(schema(t)),
    defaultValues: {},  
  });



  const [errorFetch, setErrorFetch] = useState(null);


  const [loadingEdit, setLoadingEdit] = useState(false);
  let typeurl;
  if (user.type === "supplier") typeurl = "/vendor-details/"
  else if (user.type === "agency") typeurl = "/agency-details/"
  
  const onSubmit = async (data) => {

    if(loadingEdit) return; // Prevent multiple submissions
    setLoadingEdit(true); // Set loading state to true


   
 
    clearErrors(); // Clears all errors
    

 
    try {


      const response = await api.patch(typeurl, data ); 

     
      setData(response.data)
      setUser((prevUser) => ({
        ...prevUser,
        name:response.data.name,
         company: {
    ...prevUser.company,
    country: response.data.region,
  },
        
      }));

           
      

  } catch (error) {
    let errorMessage = false; // Initialize the error message variable


    if (error?.response?.data) {
      errorMessage = ""
      Object.entries(error.response.data).forEach(([key, values]) => {

        console.log(key, values);
        //errorMessage += `${key} : ${values}\n`;
        errorMessage += `${values}\n`;


      });
    }

    // If no specific error was found, provide a default message
    if (!errorMessage) {

      errorMessage = "An unknown error occurred.";
    }

    // Set the error message in React Hook Form
    setError("root", { type: "server", message: errorMessage });
  }
  finally {
    setLoadingEdit(false); // Reset loading state
     setIsEdit(false)
  }
   


  };

  useEffect(() => {
    if(data){
     
    reset({
      name: data.name,
      phone: data.phone,
      companyname: data.company_name,
      employment_registration: data?.employment_registration,
      registration_number: data?.registration_number,
      location: data.location,
      region: data.region,
      street: data.street,
      postal_code: data.postal_code,

    });}

  },[data])

    useEffect(() => {
        console.log("Current errors:", errors);
    }, [errors]);
  const fetchData = async () => {


    setLoadingDetails(true)
    setErrorFetch(null)


    try {


    

      const response = await api.get(typeurl); // No need to wrap `data` in an object


      setData(response.data.details)

     
    } catch (error) {
      //console.error("Error submitting form:", error);
      console.log(error);
      // Extract response code if available


      setErrorFetch(error.response.data.error)
      console.log("Response Code:", error.response.data.error);


    } finally {


      setLoadingDetails(false);
    }
  }
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {



    fetchData()
  }, [])

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          {
            (loadingDetails || errorFetch) ? (
              <div style={{ textAlign: "center", margin: "10em" }}>
                {loadingDetails && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
                {errorFetch && (
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Error!</strong> {errorFetch}
                    {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
                  </div>
                )}
              </div>
            ) : (

              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header">
                    <h5>{user.type == 'agency' ? t('Agency') : t('Vendor')} {t("Details")}</h5>

                  </div>
                </div>
                {/*button Edit */}
                <div className="row">
                <div className="col-sm-12 d-flex justify-content-end align-items-center">
    <p className="text-danger mx-3">{errors.root?.message}</p>

 
    {isEdit ? (

  <button 
    form="from-company-details" 
    type="button" 
    className="btn btn-primary me-2" 
    onClick={handleSubmit(onSubmit)} 
     >
    <i className="fa-solid fa-save me-2" /> {t("Save")}
  </button>
) : (

  <button 
   
    type="button" 
    className="btn btn-primary me-2" 
    onClick={() => setIsEdit(true)}
  >
    <i className="fa-solid fa-pen me-2" /> {t("Edit")}
  </button>
)}
                   
                  </div>
                 
                </div>

                {/*button Edit endd*/}
                {/* Read-Only Form */}
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="loginbox">
                        <div className="login-right">
                          <div className="login-right-wrap">


                          <form id="from-company-details" onSubmit={handleSubmit(onSubmit)}>
                           
                                <div className="row">
                                  {/* Personal Info */}


                                  <div className="col-md-6 mb-4">
                                    <div className="separator my-4">
                                      <span>{t("ADMIN INFO")}</span>
                                    </div>
                                    {/* name, email, phone */}
                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Name")}</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={data.name}
                                        disabled={!isEdit}
                                        {...register("name")}

                                      />
                                      <p className="text-danger">{errors.name?.message}</p>
                                    </div>

                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Email")}</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={data.admin_email}
                                        disabled

                                      />

                                    </div>

                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Contact Number")}</label>
                                      <input
                                        className="form-control"
                                        type="tel"
                                        defaultValue={data.phone}
                                        disabled={!isEdit}
                                        {...register("phone")}
                                      />
                                      <p className="text-danger">{errors.phone?.message}</p>
                                    </div>
                                  </div>

                                  {/* Company Info */}
                                  <div className="col-md-6">
                                    <div className="separator my-4">
                                      <span>{t("COMPANY INFO")}</span>
                                    </div>

                                    <div className="d-flex justify-content-center mt-4">
                                      <div className="position-relative rounded border border-secondary d-flex justify-content-center align-items-center overflow-hidden bg-light" style={{ width: '150px', height: '150px', cursor: 'pointer' }}>
                                        {data.imgprofile ? (
                                          <img
                                            src={data.imgprofile}
                                            alt="Profile"
                                            className="w-100 h-100"
                                            style={{ objectFit: 'cover' }}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                        <div
                                          onMouseEnter={() => setIsHovered(true)}
                                          onMouseLeave={() => setIsHovered(false)}
                                          className=
                                          {isHovered ?
                                            ("position-absolute w-100 h-100 bg-secondary opacity-50 d-flex justify-content-center align-items-center text-center")
                                            :
                                            ("position-absolute w-100 h-100 bg-secondary opacity-0 d-flex justify-content-center align-items-center text-center")
                                          }
                                          style={{ objectFit: 'cover' }} data-bs-toggle="modal" data-bs-target="#update_image">
                                          <p className="text-center"><Icon.Edit size={25} color="black" /></p>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="input-block mb-3">
                                      <label className="form-control-label">{t("Company Name")}</label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={data.company_name}
                                        disabled={!isEdit}
                                        {...register("companyname")}
                                      />
                                      <p className="text-danger">{errors.companyname?.message}</p>
                                    </div>
                                    {
                                      (user.type === "agency") &&
                                      <>
                                        <div className="input-block mb-3">
                                          <label className="form-control-label">{t("Employment Registration")}</label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={data.employment_registration}
                                            disabled={!isEdit}
                                            {...register("employment_registration")}
                                          />
                                          <p className="text-danger">{errors.employment_registration?.message}</p>
                                        </div>
                                        <div className="input-block mb-3">
                                          <label className="form-control-label">{t("Registration Number")}</label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={data.registration_number}
                                            disabled={!isEdit}
                                            {...register("registration_number")}
                                          />
                                          <p className="text-danger">{errors.registration_number?.message}</p>
                                        </div>
                                      </>
                                    }



                                    {/* Address section */}
                                    {!isEdit ?
                                      <>
                                        <div className="input-block mb-3">
                                          <label className="form-control-label">{t("Address")}</label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={data.location}
                                            disabled={!isEdit}

                                          />
                                        </div>


                                        <div className="input-block mb-3">
                                          <label className="form-control-label">{t("Country")}</label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={data.region}
                                            disabled

                                          />
                                        </div>
                                      </>
                                      :
                                      <AddressRegistration register={register} errors={errors} setValue={setValue} />

                                    }

                                    {/* Address section */}
                                  </div>
                                </div>
                            
                            </form>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End Read-Only Form */}


              </div>
            )}
        </div>
      </div>
      <UpdateProfileImage onRefresh={fetchData} />
    </>


  );
}
CompanyDetails.propTypes = {
  user: PropTypes.shape({
    company: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
};

export default CompanyDetails;

